import { ApolloError } from "@apollo/client"
import { GraphQLError, GraphQLFormattedError } from "graphql"
import { toast } from "~/ui/use-toast"

/** based on app/graphql/validation_error.rb */
type ValidationError = {
  field: string
  resource: string
  fullMessage: string
  message: string
  type: string
}

type ValidationErrorPayload = {
  extensions: {
    code: "VALIDATION_ERROR"
    validationErrors: Array<ValidationError>
  }
  message: string
}

const isApolloError = (t: readonly GraphQLFormattedError[] | ApolloError): t is ApolloError => {
  return (t as ApolloError).graphQLErrors !== undefined
}

const getGraphqlErrors = (_errors?: readonly GraphQLFormattedError[] | ApolloError) => {
  if (!_errors) return
  let errors: Array<GraphQLError | GraphQLFormattedError> = []

  if (isApolloError(_errors)) {
    errors = [..._errors.graphQLErrors]
  } else {
    errors = [..._errors]
  }

  return errors
}

const displayErrors = (_errors?: readonly GraphQLFormattedError[] | ApolloError) => {
  console.log("got errors", _errors)

  if (!_errors) return
  const errors = getGraphqlErrors(_errors)

  const validationErrors = errors?.find((error) => error.extensions?.code === "VALIDATION_ERROR")

  if (validationErrors) {
    toast({
      title: validationErrors.message || "An error has occurred, please try again",
      variant: "destructive",
    })
  } else if (isApolloError(_errors)) {
    toast({
      title: _errors.message || "An error has occurred, please try again",
      variant: "destructive",
    })
  }
}

export { displayErrors, getGraphqlErrors, type ValidationErrorPayload }
